import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import { useDispatch, useSelector } from 'react-redux';

const {
    actions: userSettingsActions,
    types: UserSettingsTypes,
    selectors: { selectOnboarding },
} = MojitoServices.UserSettings;
const { INPLAY_FAVORITES } = UserSettingsTypes.ONBOARDING_TYPES;
const { FlexPane, Text, ImageButton } = MojitoPresentation.Components;

export default function FavoritesContentOnboarding(props) {
    const {
        mojitoTools: {
            config,
            stringResolver,
            appContext: { systemSettings },
        },
        closable,
    } = props;

    const showOnboarding = useSelector(state => !selectOnboarding(state)[INPLAY_FAVORITES]?.passed);
    const applicationMode = systemSettings().applicationMode.toUpperCase();
    const dispatch = useDispatch();
    const hideOnboarding = () => {
        dispatch(
            userSettingsActions.updateOnboardingProgress({
                [INPLAY_FAVORITES]: { passed: true },
            })
        );
    };

    if (closable && !showOnboarding) {
        return null;
    }

    return (
        <FlexPane class="ta-FavoritesContentOnboarding" config={config.container}>
            <FlexPane config={config.textContainer}>
                <Text class="ta-headerText" config={config.header}>
                    {stringResolver.resolveString('$INPLAY.FAVORITES_ONBOARDING.HEADER')}
                </Text>
                <Text class="ta-messageText" config={config.message}>
                    {stringResolver.resolveString(
                        `$INPLAY.FAVORITES_ONBOARDING.MESSAGE.${applicationMode}`
                    )}
                </Text>
            </FlexPane>
            {closable && <CloseButton hideOnboarding={hideOnboarding} config={config} />}
        </FlexPane>
    );
}

const CloseButton = ({ hideOnboarding, config }) => (
    <ImageButton
        class="ta-CloseFavoritesOnboardingButton"
        onClick={hideOnboarding}
        config={config.closeButton}
    />
);
